export function portalLinksForIdentity(identity, current = "studio", { reviewerPreviewSandboxEnabled = false } = {}) {
  const capabilities = identity?.capabilities || {};
  const links = [];
  if (capabilities.photoLibrary === true && current !== "photo-library") links.push({ id: "photo-library", label: "Photo Library", href: "/photo-library/" });
  if (current !== "studio") links.push({ id: "studio", label: "Studio", href: "/" });
  if (capabilities.adminSettings && current !== "admin") links.push({ id: "admin", label: "Admin Portal", href: "/admin/" });
  const reviewerVisible = capabilities.reviewer === true
    || (reviewerPreviewSandboxEnabled && capabilities.administration?.manageRoles === true);
  if (reviewerVisible && current !== "reviewer") links.push({ id: "reviewer", label: "Reviewer Portal", href: "/reviewer/" });
  // Central CCD can open the HC routing directory without being granted
  // Reviewer access to request photos, history or decisions.
  if (!reviewerVisible && capabilities.ccdApprover === true && current !== "reviewer") {
    links.push({ id: "hc-workflow", label: "HC approvers by BU", href: "/reviewer/" });
  }
  if (capabilities.directUpdater && current !== "direct-update") links.push({ id: "direct-update", label: "Direct Updater", href: "/direct-update/" });
  return links;
}
